// extracted by mini-css-extract-plugin
export var csatScore = "_mz-5";
export var header = "_mz-1";
export var panelWrapper = "_mz-2";
export var postPreview = "_mz-3";
export var rightContent = "_mz-0";
export var wrappingText = "_mz-4";